import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <h1 className="text-9xl font-bold text-primaryBlue mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-gray-900 mb-4">
          {t('notFound.title')}
        </h2>
        <p className="text-gray-600 mb-8">
          {t('notFound.description')}
        </p>
        <Link
          to="/"
          className="inline-block bg-primaryBlue text-white px-6 py-3 font-semibold rounded-lg hover:bg-blue-700 transition-colors"
        >
          {t('notFound.backHome')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 